module.exports = __webpack_public_path__ + "static/OurValues2-7fd25cabec2c7417b81fc89dee180e06.png";